import(/* webpackChunkName: "app" */ "app/tools/start")
  .then(importedFile => {
    // At run time, we'll import a file having not the same name
    // and it will prevents future pbs of cached files in the browser
    // don't running with new API changes
    importedFile.startApp()
  })
  .catch(error => {
    console.error("An error occurred while loading app", error)
  })
